import * as React from 'react';

import { TFIOSuggestion, TResetSuggested, TSetInputValue, TSetPlaceholder, TSetGender } from '../../../types/fio';
import { getNewInputValue } from './getNewInputValue';
import { getNewGender } from './getNewGender';
import { getPlaceholderText } from './getPlaceholderText';

export interface IUseOnClickItemHandlerParams {
  inputValue: string;
  suggestFiltered: TFIOSuggestion[];
  inputRef: React.RefObject<HTMLInputElement>;
  resetSuggested: TResetSuggested;
  setInputValue: TSetInputValue;
  setPlaceholder: TSetPlaceholder;
  setGender: TSetGender;
}

export function useOnClickItemHandler({
  inputValue,
  suggestFiltered,
  inputRef,
  resetSuggested,
  setInputValue,
  setPlaceholder,
  setGender,
}: IUseOnClickItemHandlerParams) {
  return React.useCallback(
    (value: string) => {
      const newValue = getNewInputValue(value, inputValue);
      const newValueSplit = newValue.split(' ');

      setInputValue(newValue);
      resetSuggested();

      const placeholder = getPlaceholderText(newValueSplit);
      setPlaceholder(placeholder);

      const newGender = getNewGender(value, suggestFiltered);
      if (newGender) {
        setGender(newGender);
      }

      const isFullFIO = newValueSplit.length === 3 && newValueSplit[0] && newValueSplit[1] && newValueSplit[2];
      if (!isFullFIO) {
        /**
         * setTimeout - хак из-за асинхронного обновления value в инпуте и событии onFocus
         */
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        setTimeout(() => inputRef.current!.focus());
      }
    },
    [inputValue, suggestFiltered, setInputValue, resetSuggested, setPlaceholder, inputRef, setGender],
  );
}
